
(function() {
  var result = { translations: { "pl": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Dzia\u0142ania" }, "tag": { "remove": "Usu\u0144 tag" }, "Select": { "noResults": "Brak wynik\xF3w", "searchPlaceholder": "Szukaj\u2026", "clearSelections": "Wyczy\u015B\u0107 zaznaczenia" }, "ErrorMessage": { "error": { "title": "Nie wszystko zosta\u0142o stracone." }, "notFound": { "title": "Nie ka\u017Cdy b\u0142\u0105dzi, kto w\u0119druje." }, "badRequest": { "title": "Podczas \u0142adowania strony wyst\u0105pi\u0142 problem." }, "expired": { "title": "Przepraszamy." }, "sessionId": { "prefix": "Identyfikator sesji:" } }, "ProgressSteps": { "completedStep": "Uko\u0144czony krok", "incompleteStep": "Nieuko\u0144czony krok" }, "Paginator": { "label": "Podzia\u0142 strony", "pageNumber": { "currentIndicator": "Obecnie jeste\u015B", "description": "Strona" }, "firstPage": { "label": "Pierwszy", "description": "Pierwsza strona" }, "previousPage": { "label": "Poprzednia", "description": "Poprzednia strona" }, "nextPage": { "label": "Dalej", "description": "Nast\u0119pna strona" }, "lastPage": { "label": "Ostatnia", "description": "Ostatnia strona" } }, "Datagrid": { "noData": { "Title": "Brak dost\u0119pnych danych", "Description": "Brak dost\u0119pnych danych do wy\u015Bwietlenia." }, "noResults": { "Title": "Brak wynik\xF3w", "Description": "Zmie\u0144 wyszukiwanie i filtry, aby odnale\u017A\u0107 szukane zasoby.", "ClearActionLabel": "Wyczy\u015B\u0107 wyszukiwanie i filtry" }, "toolbar": { "selectedRows": { "one": "Wybrano {{count}} wiersz", "other": "Wybrano {{count}} wiersze", "clearSelection": "Wyczy\u015B\u0107 zaznaczenie", "selectAll": "Wybierz wszystkie wiersze ({{totalRows}})" }, "search": { "placeholder": "Szukaj", "label": "Szukaj", "clearSearch": "Wyczy\u015B\u0107 wyszukiwanie" } }, "pagination": { "visibleRows": "{{visibleRows}} z {{totalRows}} wynik\xF3w", "itemsPerPage": "Pozycji na stron\u0119", "countPerPage": { "one": "{{count}} na stron\u0119", "other": "{{count}} na stron\u0119", "few": "{{count}} na stron\u0119", "many": "{{count}} na stron\u0119" } }, "SkeletonGrid": { "loading": "\u0141adowanie" }, "DataGridColumnManagementPanel": { "description": "Wybierz, kt\xF3re w\u0142a\u015Bciwo\u015Bci maj\u0105 by\u0107 wy\u015Bwietlane jako kolumny. Nast\u0119pnie przenie\u015B w\u0142a\u015Bciwo\u015Bci w g\xF3r\u0119 lub w d\xF3\u0142, lub przeci\u0105gnij i upu\u015B\u0107, aby zmieni\u0107 kolejno\u015B\u0107 ich wy\u015Bwietlania.", "removeAllColumns": "Usu\u0144 wszystkie kolumny", "update": "Aktualizacja", "cancel": "Anuluj", "edit": "Edytuj kolumny" } } }, "ui": { "UIAbstractPageSection": { "page": "Sekcja strony" }, "UICarousel": { "current": "Wy\u015Bwietla element {{currentStepDisplayNumber}} z {{totalSteps}}", "prev": "Wstecz", "next": "Dalej", "tip": "U\u017Cyj klawiszy strza\u0142ek, aby przegl\u0105da\u0107 inne elementy" }, "UIColorSwatch": { "label": "Wybieranie koloru: {{value}}", "noColorLabel": "Wybieranie kolor\xF3w, nie wybrano \u017Cadnego koloru." }, "UIButtonCollapser": { "dropdownLabel": "Dzia\u0142ania" }, "UIErrorMessage": { "error": { "title": "Nie wszystko zosta\u0142o stracone." }, "notFound": { "title": "Nie ka\u017Cdy b\u0142\u0105dzi, kto w\u0119druje." }, "badRequest": { "title": "Podczas \u0142adowania strony wyst\u0105pi\u0142 problem." }, "expired": { "title": "Przepraszamy." } }, "UIPanelNavigator": { "backButton": "Przejd\u017A do poprzedniego etapu" }, "UILoadingSpinner": { "busyText": "\u0141adowanie", "completedText": "Wczytano" }, "UISideNav": { "navigationLandmark": "Dodatkowe" }, "UISortTH": { "ascendingSort": "Sortowanie rosn\u0105co. Naci\u015Bnij, aby sortowa\u0107 malej\u0105co.", "descendingSort": "Sortowanie malej\u0105co. Naci\u015Bnij, aby sortowa\u0107 rosn\u0105co.", "pressToSort": "Naci\u015Bnij, aby w\u0142\u0105czy\u0107 sortowanie." }, "autosizedTextInput": { "charactersRemaining": "Pozosta\u0142o znak\xF3w: {{value}}" }, "time": { "today": "Dzisiaj o: {{time}}", "yesterday": "Wczoraj o: {{time}}", "datetime": "{{date}} o {{time}}" }, "progress": { "percentComplete": "Uko\u0144czono {{percent}}" }, "datePicker": { "dateSelected": "Wybrano {{date}}.", "noDateSelected": "Nie wybrano daty.", "dateBelowMin": "Musisz wybra\u0107 nowsz\u0105 dat\u0119", "dateAboveMax": "Musisz wybra\u0107 starsz\u0105 dat\u0119", "invalidDate": "Nieprawid\u0142owa data", "today": "Dzisiaj", "clear": "Wyczy\u015B\u0107", "placeholder": { "month": "MM", "day": "DD", "year": "RRRR" }, "nextMonth": "Nast\u0119pny miesi\u0105c", "prevMonth": "Poprzedni miesi\u0105c" }, "dateRange": { "startDate": "Data rozpocz\u0119cia", "endDate": "Data zako\u0144czenia", "endDateBeforeStartDate": "Data zako\u0144czenia musi by\u0107 p\xF3\u017Aniejsza ni\u017C data rozpocz\u0119cia.", "startDateAfterEndDate": "Data rozpocz\u0119cia musi by\u0107 wcze\u015Bniejsza ni\u017C data zako\u0144czenia.", "to": "do" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026i {{count}} wi\u0119cej.", "loadMore": "Za\u0142aduj wi\u0119cej" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Dodaj" }, "UIAvatarHoverlay": { "text": "Zmie\u0144 zdj\u0119cie" }, "UIChangeArrow": { "decrease": "Spadek o", "increase": "Wzrost o" }, "UICopyInput": { "label": "Tekst", "title": "Kopiuj do schowka", "tooltipCopied": "Skopiowano" }, "UIConfirm": { "defaultConfirm": "Tak", "defaultReject": "Nie" }, "UICloseButton": { "label": "Zamknij" }, "UIDateRangePicker": { "rangeType": { "ALL": "Ca\u0142y czas", "THIS_DAY": "Dzisiaj", "LAST_DAY": "Wczoraj", "THIS_WEEK": "Ten tydzie\u0144", "LAST_WEEK": "Ostatni tydzie\u0144", "THIS_MONTH": "Ten miesi\u0105c", "LAST_MONTH": "Ostatni miesi\u0105c", "LAST_THIRTY_DAYS": "Ostatnie 30 dni", "LAST_THREE_MONTHS": "Ostatnie 3 miesi\u0105ce", "THIS_QUARTER": "Ten kwarta\u0142", "LAST_QUARTER": "Ostatni kwarta\u0142", "THIS_YEAR": "Ten rok", "LAST_YEAR": "Ostatni rok", "CUSTOM": "Niestandardowy przedzia\u0142 czasu" } }, "UIDropdownSelect": { "placeholder": "Nie wybrano warto\u015Bci" }, "UIEditableControls": { "cancel": "Anuluj", "save": "Zapisz" }, "UIExpandableText": { "collapseButtonText": "Wy\u015Bwietl mniej", "expandButtonText": "Wy\u015Bwietl wi\u0119cej" }, "UIFileInput": { "defaultChangeLabel": "Zmie\u0144 plik", "defaultSelectLabel": "Wybierz plik" }, "UIIconRating": { "ariaValueText": "{{value}} z {{maxValue}}" }, "UILink": { "externalTitle": "\u0141\u0105cze otworzy si\u0119 w nowym oknie" }, "UILoading": { "title": "Wczytywanie\u2026" }, "UILockBadge": { "title": "Ta funkcja jest zablokowana" }, "UIPaginator": { "label": "Podzia\u0142 strony", "pageNumber": { "currentIndicator": "Obecnie jeste\u015B", "description": "Strona" }, "firstPage": { "label": "Pierwszy", "description": "Pierwsza strona" }, "previousPage": { "label": "Poprzednia", "description": "Poprzednia strona" }, "nextPage": { "label": "Dalej", "description": "Nast\u0119pna strona" }, "lastPage": { "label": "Ostatnia", "description": "Ostatnia strona" } }, "UIPreviousButton": { "label": "Wstecz" }, "UINextButton": { "label": "Dalej" }, "UINumberRating": { "lowRangeLabel": "Zdecydowanie si\u0119 nie zgadzam", "highRangeLabel": "Zdecydowanie si\u0119 zgadzam" }, "UISearchableSelectInput": { "placeholder": "Szukaj" }, "UISearchInput": { "placeholder": "Szukaj", "minimumSearchMessage": { "one": "Wprowad\u017A jeszcze 1 znak", "other": "Wprowad\u017A jeszcze {{count}} znaku", "few": "Wprowad\u017A jeszcze {{count}} znaki", "many": "Wprowad\u017A jeszcze {{count}} znak\xF3w" }, "clearButton": "Wyczy\u015B\u0107 dane wej\u015Bciowe" }, "UISelect": { "allOptionsSelected": "Wybrano wszystkie opcje", "createOption": "Wybierz opcj\u0119 \u201E{{label}}\u201D", "plusMore": "+ {{count}} wi\u0119cej", "andMore": "\u2026i {{count}} wi\u0119cej.", "loadMore": "Za\u0142aduj wi\u0119cej", "noResults": "Brak wynik\xF3w", "placeholder": "Szukaj", "typeToSearch": "Zacznij wpisywa\u0107 tekst, aby wyszuka\u0107 fraz\u0119" }, "UITable": { "selectableTableRow": { "toggleSelection": "Prze\u0142\u0105cz wyb\xF3r wiersza" } }, "UITabs": { "moreDropdownLabel": "Wi\u0119cej" }, "UITeaseNotification": { "optionsButtonTooltipText": "Poka\u017C opcje" }, "UITimePicker": { "placeholder": "Wybierz godzin\u0119" }, "UIToggle": { "checkedLabel": "W\u0141.", "uncheckedLabel": "WY\u0141" }, "UITypeahead": { "noMatchesFound": "Nie znaleziono wynik\xF3w", "noOptions": "Brak" }, "UIWizard": { "back": "Wstecz", "cancel": "Anuluj", "done": "Gotowe", "next": "Dalej", "stepCount": "Krok {{stepNumber}} z {{stepCount}}" }, "XSSTooltip": { "explanation": "Ta \u0142\u0105cze zosta\u0142o zablokowane dla Twojego bezpiecze\u0144stwa." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "pl": "static-1.4543"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4543",
    "ar-eg": "static-1.4543",
    "bg": "static-1.4543",
    "bn": "static-1.4543",
    "ca-es": "static-1.4543",
    "cs": "static-1.4543",
    "da": "static-1.4543",
    "de": "static-1.4543",
    "el": "static-1.4543",
    "en-gb": "static-1.4543",
    "en": "static-1.4543",
    "es-mx": "static-1.4543",
    "es": "static-1.4543",
    "et": "static-1.4543",
    "fi": "static-1.4543",
    "fr-ca": "static-1.4543",
    "fr": "static-1.4543",
    "he-il": "static-1.4543",
    "hi": "static-1.4543",
    "hr": "static-1.4543",
    "hu": "static-1.4543",
    "id": "static-1.4543",
    "it": "static-1.4543",
    "ja": "static-1.4543",
    "ko": "static-1.4543",
    "lt": "static-1.4543",
    "ms": "static-1.4543",
    "nl": "static-1.4543",
    "no": "static-1.4543",
    "pl": "static-1.4543",
    "pt-br": "static-1.4543",
    "pt-pt": "static-1.4543",
    "ro": "static-1.4543",
    "ru": "static-1.4543",
    "sk": "static-1.4543",
    "sl": "static-1.4543",
    "sv": "static-1.4543",
    "th": "static-1.4543",
    "tl": "static-1.4543",
    "tr": "static-1.4543",
    "uk": "static-1.4543",
    "vi": "static-1.4543",
    "zh-cn": "static-1.4543",
    "zh-hk": "static-1.4543",
    "zh-tw": "static-1.4543"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:pl', {version: 'static-1.4543'}); }
})();



(function() {
  var result = { translations: { "pl": { "placeholder": "symbol zast\u0119pczy" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "pl": "static-3.6206"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6206",
    "ar-eg": "static-3.6206",
    "bg": "static-3.6206",
    "bn": "static-3.6206",
    "ca-es": "static-3.6206",
    "cs": "static-3.6206",
    "da": "static-3.6206",
    "de": "static-3.6206",
    "el": "static-3.6206",
    "en-gb": "static-3.6206",
    "en": "static-3.6206",
    "es-mx": "static-3.6206",
    "es": "static-3.6206",
    "et": "static-3.6206",
    "fi": "static-3.6206",
    "fr-ca": "static-3.6206",
    "fr": "static-3.6206",
    "he-il": "static-3.6206",
    "hi": "static-3.6206",
    "hr": "static-3.6206",
    "hu": "static-3.6206",
    "id": "static-3.6206",
    "it": "static-3.6206",
    "ja": "static-3.6206",
    "ko": "static-3.6206",
    "lt": "static-3.6206",
    "ms": "static-3.6206",
    "nl": "static-3.6206",
    "no": "static-3.6206",
    "pl": "static-3.6206",
    "pt-br": "static-3.6206",
    "pt-pt": "static-3.6206",
    "ro": "static-3.6206",
    "ru": "static-3.6206",
    "sk": "static-3.6206",
    "sl": "static-3.6206",
    "sv": "static-3.6206",
    "th": "static-3.6206",
    "tl": "static-3.6206",
    "tr": "static-3.6206",
    "uk": "static-3.6206",
    "vi": "static-3.6206",
    "zh-cn": "static-3.6206",
    "zh-hk": "static-3.6206",
    "zh-tw": "static-3.6206"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:pl', {version: 'static-3.6206'}); }
})();



(function() {
  var result = { translations: { "pl": { "app": { "htmlTitle": "Interfejs u\u017Cytkownika \u0142\u0105czy viralowych", "welcomeHome": "Cze\u015B\u0107, {{ firstName }},", "yourAppIsReady": "Twoja aplikacja jest gotowa", "aSecondPage": "Druga strona, na kt\xF3rej zmie\u015Bci si\u0119 wi\u0119cej tre\u015Bci", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Wype\u0142nij t\u0119 pust\u0105 stron\u0119 ", createElement( options, "Link", props.linkProps, "komponentami" ), " pod adresem ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Utw\xF3rz w\u0142asne bezp\u0142atne formularze</strong>, aby przyci\u0105ga\u0107 leady ze strony internetowej." }, "liveChat": { "linkCta": "<strong>Dodaj czat na \u017Cywo.</strong> Po\u0142\u0105cz si\u0119 z odwiedzaj\u0105cymi. Bezp\u0142atnie.", "ariaLabel": "Dodaj czat na \u017Cywo. Po\u0142\u0105cz si\u0119 z odwiedzaj\u0105cymi. Bezp\u0142atnie." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Dodaj czat na \u017Cywo.</strong> Po\u0142\u0105cz si\u0119 z odwiedzaj\u0105cymi. Bezp\u0142atnie.", "ariaLabel": "[Int] Dodaj czat na \u017Cywo. Po\u0142\u0105cz si\u0119 z odwiedzaj\u0105cymi. Bezp\u0142atnie." }, "meetings": { "linkCta": "<strong>Utw\xF3rz darmow\u0105 stron\u0119 do rezerwowania spotka\u0144</strong> w celu szybszego ich planowania." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "pl": "static-1.3793"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3793",
    "ar-eg": "static-1.3793",
    "bg": "static-1.3793",
    "bn": "static-1.3793",
    "ca-es": "static-1.3793",
    "cs": "static-1.3793",
    "da": "static-1.3793",
    "de": "static-1.3793",
    "el": "static-1.3793",
    "en-gb": "static-1.3793",
    "en": "static-1.3793",
    "es-mx": "static-1.3793",
    "es": "static-1.3793",
    "et": "static-1.3793",
    "fi": "static-1.3793",
    "fr-ca": "static-1.3793",
    "fr": "static-1.3793",
    "he-il": "static-1.3793",
    "hi": "static-1.3793",
    "hr": "static-1.3793",
    "hu": "static-1.3793",
    "id": "static-1.3793",
    "it": "static-1.3793",
    "ja": "static-1.3793",
    "ko": "static-1.3793",
    "lt": "static-1.3793",
    "ms": "static-1.3793",
    "nl": "static-1.3793",
    "no": "static-1.3793",
    "pl": "static-1.3793",
    "pt-br": "static-1.3793",
    "pt-pt": "static-1.3793",
    "ro": "static-1.3793",
    "ru": "static-1.3793",
    "sk": "static-1.3793",
    "sl": "static-1.3793",
    "sv": "static-1.3793",
    "th": "static-1.3793",
    "tl": "static-1.3793",
    "tr": "static-1.3793",
    "uk": "static-1.3793",
    "vi": "static-1.3793",
    "zh-cn": "static-1.3793",
    "zh-hk": "static-1.3793",
    "zh-tw": "static-1.3793"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:pl', {version: 'static-1.3793'}); }
})();


